import { Component, EventEmitter, OnInit, Input, Output } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { RequestReopenStageId } from "src/app/model/enum/request-reopen-stage-ids.enum";
import { RequestUserStatus } from "src/app/model/enum/request-user-status.enum";
import { ReqVerificationStage } from "src/app/model/req-verification-stage.model";
import { TargetEvaluator } from "src/app/requests/enums/target-evaluator.enum";
import { RequestVerificationStatus } from "src/app/requests/enums/verification-status.enum";
import { RequestHelpersService } from "src/app/services/request-helpers/request-helpers.service";

@Component({
    selector: 'select-approvers',
    templateUrl: './select-approvers.component.html',
    styleUrls: ["./select-approvers.component.scss"]
})
export class SelectApproversComponent implements OnInit {
    private _internalReopenStageId: string;
    private _internalVerificationStatus: RequestVerificationStatus;
    private _internalReopenStage: ReqVerificationStage;

    @Input() form: UntypedFormGroup;
    @Input() title: string;
    @Input() additionalClass: string;
    @Input() verificationStages: ReqVerificationStage[];
    @Input()
        get reopenStage() { 
            return this._internalReopenStage
        }
        set reopenStage(value: ReqVerificationStage) {
            this._internalReopenStage = value;
            this.setShouldDisplayStages();
        };
    @Input() currentStage: ReqVerificationStage;
    @Input() get verificationStatus() { 
            return this._internalVerificationStatus
        }
        set verificationStatus(value: RequestVerificationStatus) {
            this._internalVerificationStatus = value;
            this.setShouldDisplayStages();
        };
    @Input() 
        get reopenStageId() { 
            return this._internalReopenStageId
        }
        set reopenStageId(value: string) {
            this._internalReopenStageId = value;
            this.setShouldDisplayStages();
        };

    @Output() approverChanged = new EventEmitter<any>();

    RequestReopenStageId = RequestReopenStageId;
    RequestUserStatus = RequestUserStatus;
    RequestVerificationStatus = RequestVerificationStatus;
    TargetEvaluator = TargetEvaluator;

    shouldDisplayAnyStages: boolean;
    shouldDisplayStages: boolean[];

    expanded: boolean;
    uniqueId: string = `approver-${Math.random().toString(36).substr(2, 9)}`;

    constructor(
        public requestHelpersService : RequestHelpersService,
    ) {}


    ngOnInit() {
        this.expanded = true;
        this.setShouldDisplayStages();
    }

    toggle = () => this.expanded = !this.expanded;

    onApproverChanged = () => {
        this.approverChanged.emit();
    }

    private setShouldDisplayStages() {
        if (this.verificationStages) {
            this.shouldDisplayStages = this.verificationStages.map((verificationStage: ReqVerificationStage) => this.shouldDisplayStage(verificationStage));
            this.shouldDisplayAnyStages = this.shouldDisplayStages.find(s => s);
        }
    }

    private shouldDisplayStage(verificationStage: ReqVerificationStage) : boolean {
        // APPROVAL CASES
        if ((this.verificationStatus === RequestVerificationStatus.APPROVED || 
                this.verificationStatus === RequestVerificationStatus.SKIPPED) &&
            this.currentStage &&
            this.compareStageOrder(this.currentStage, verificationStage) < 0) {
            return true;

        // REOPEN CASES
        } else if(this.verificationStatus === RequestVerificationStatus.REOPEN) {
            if (this.reopenStageId === RequestReopenStageId.ReopenToUserStageId) {
                return true
            } else if (this.reopenStageId === RequestReopenStageId.ReopenFollowupToUserStageId && verificationStage.Followup === 1) {
                return true
            } else if (!this.reopenStage) {
                return false;
            } else {
                return this.compareStageOrder(this.reopenStage, verificationStage) <= 0;
            }
        }

        return false;
    }

    private compareStageOrder(stage1: ReqVerificationStage, stage2: ReqVerificationStage) {
        if (stage1.Order == stage2.Order && stage1.Followup == stage2.Followup) {
            return 0;
        } else if ( stage1.Order < stage2.Order && stage1.Followup === stage2.Followup || stage1.Followup < stage2.Followup) {
            return -1;
        } else {
            return 1;
        }
    }
}
